"use client";

import type React from "react";
import { useState } from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { redirect } from "next/navigation";

export default function Searchbar() {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = () => {
    if (searchQuery.trim()) {
      redirect(`/search?q=${searchQuery}`);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="w-full max-w-md mx-2">
      <div className="flex gap-2">
        <Input
          type="search"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={handleKeyPress}
          className="flex-1"
        />
        <Button
          onClick={handleSearch}
          className="px-4 bg-green-700 hover:bg-green-800 hover:cursor-pointer"
        >
          <Search className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
